import { Rect, Line, Stage, Layer } from 'react-konva';
import Rider from './Rider';

function Road(props) {

    // surface (asphalt, cobbles, schotter, mud)
    function getXPosition(x) {
        return props.length * props.scale - props.scale - props.scale * x;
    }
    function getYPosition(y) {
        return props.scale * y;
    }

    if (props) {
        return <>
            <Stage key={'konvaStage'} width={1500} height={500}>
                <Layer>
                    <Rect key={'road'}
                        x={props.x}
                        y={props.y}
                        width={props.length * props.scale}
                        height={props.width * props.scale}
                        fill={'darkgrey'}
                    />
                    <Line key={'middleLine'} points={[props.x, props.y + props.width * props.scale / 2, props.x + props.length * props.scale, props.y + props.width * props.scale / 2]}
                        stroke={'white'}
                        strokeWidth={props.scale / 6}
                        dash={[props.scale, props.scale]} />

                    {props.racers.map(racer =>
                        <>
                            <Rider key={'rider' + racer.rider.id}
                                x={getXPosition(racer.position.x)}
                                y={getYPosition(racer.position.y)}
                                racer={racer}                                
                                scale={props.scale}
                                selectionMode={racer.selectionMode} 
                                info={props.info}
                                select={props.select}
                                unselect={props.unselect}
                                selectTarget={props.selectTarget}
                                image={racer.jerseyFile}
                                />
                        </>)}
                </Layer>
            </Stage>
        </>;
    }
    else return <h2>Nothing</h2>;


}

export default Road;

